// entry: 子应用访问地址
// activeRule: 触发访问子应用的前缀
// container: 在主应用中的挂载节点
// sanbox： 解决css冲突(layout进行统一处理) 不需要单独处理
import { ACTIONS } from "./actions";
const microApps = [
  {
    name: "umi",
    entry: "http://localhost:8000/umi",
    activeRule: "/umi",
  },
];

const apps = microApps.map((item) => {
  return {
    ...item,
    container: "#child-container",
    props: {
      ROUTER_BASE: item.activeRule, // 下发基础路由
      ACTIONS,
    },
  };
});
export default apps;
